import getWithToken from "./base/get-with-token";

const getTotalPercentageReceived = (searchData) =>
  getWithToken(`/total-percentage-devices`)(searchData);

export default getTotalPercentageReceived;
